import { render, staticRenderFns } from "./IconSlots.vue?vue&type=template&id=62c00434&"
import script from "./IconSlots.vue?vue&type=script&lang=js&"
export * from "./IconSlots.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports